import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";

type TInput = { offerId: number };
type TOutput = void;

export default class DeleteOfferApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.DELETE;

  resolveUri({ offerId }: TInput): string {
    return `/fe-api/offer/${offerId}`;
  }
}
